import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["addResourceBundle"];
import { useTranslation } from "@crehana/i18n";
import { CREHANA_DIPLOMAS_TRANSLATION_KEY } from "../constants";
import { DiplomasLocalesBundle } from "../i18n";
export var useDiplomasTranslation = function useDiplomasTranslation() {
  var _useTranslation = useTranslation(CREHANA_DIPLOMAS_TRANSLATION_KEY),
    addResourceBundle = _useTranslation.addResourceBundle,
    translationContextValue = _objectWithoutProperties(_useTranslation, _excluded);
  addResourceBundle(DiplomasLocalesBundle);
  return translationContextValue;
};